import { render, staticRenderFns } from "./Websites.vue?vue&type=template&id=3b050765"
import script from "./Websites.vue?vue&type=script&lang=js"
export * from "./Websites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports